$(document).ready(function(){
  var email = null;
  var paymessage = {
    email: null,
    package: null,
    discount:null
  };
  var price = {
    normal: {
      price: [3999,9999,19999,49999],
      title: "标准版"
    },
    plus: {
      price: [29999,57999,89999,149999],
      title: "增强版"
    },
    name: ["网站套餐","门户套餐","教育套餐","大客户套餐"],
    ratio: ["预存1%","预存2%"],
    stepone: 1,
    steptwo: 2,
    stepthree: 3
  };
  // 登录
  var $juser = $("#juser");
  var islogin;
  function setLogin(){
    var url = "http://activity.polyv.net/getUser";
    $.ajax({
      url: url,
      xhrFields: {
                      withCredentials: true
              },
      // type: "POST",
      dataType: "jsonp",
      crossDomain: true
    }).done(function(json){
      if(json.status === "fail"){
        $juser.children("p").hide();
        $juser.children("div").show();
        $("#loginBtn2").show();
      }else{
        paymessage.email = json.email;
        $juser.children("p").show();
        $juser.children("div").hide();
        $("#loginBtn2").hide();
        $("#useremail").html(json.email);
      }
    });
  }
setLogin();

function getCount(){
  var url = "http://activity.polyv.net/winner/16-06/egg/count";
  $.ajax({
    url: url,
    dataType: "jsonp"
  }).done(function(data){
    $("#eggCount").html(data.count);
  });
}
getCount();

function getActivityList(){
  var url = "http://activity.polyv.net/order/16-06/getOrder";
  var $giftList2 = $("#giftList2");
  $.ajax({
    url: url,
    dataType: "jsonp"
  }).done(function(data){
    if(data.length>0){
      $(data).each(function(index) {
        var text = "您已预存 <span class='savemoney'>"+ this.totalPay +"元</span>，活动期间可抵扣<span class='savemoney'>"+ this.save +"元</span><br />";
        $giftList2.append(text);
      });
    }else{
      $giftList2.html("预存一定金额，可享全年超低价盛惠哦");
    }
  });
}
getActivityList();

  $("#loginform").submit(function(){
    var url = "http://activity.polyv.net/login";
    var data = $(this).serializeArray();
    $.ajax({
      url: url,
      xhrFields: {
                      withCredentials: true
              },
      // type: "POST",
      dataType: 'jsonp',
      crossDomain: true,
      data: $(this).serialize()
    }).done(function(json){
    if(json.status === "failure"){
      alert(json.errorMsg);
    }else{
      if(json.status==="fail"){
        alert(json.message);
        $("#loginBtn2").show();
      }else{
        paymessage.email = json.email;
        $juser.children("p").show();
        $juser.children("div").hide();
        $("#loginBtn2").hide();
        $("#useremail").html(json.email);
        $("#lean_overlay").click();
        getGiftList();
        getActivityList();
        getCount();
        getTurnGift();
      }
    }
    });
    return false;
  });

// 退出登录
  $("#quitLogin").on("click",function(){
    paymessage.email = null;
    var url = "http://activity.polyv.net/loginout";
    $.ajax({
      url: url,
      xhrFields: {
                      withCredentials: true
              },
      // type: "POST",
      dataType: 'jsonp',
      crossDomain: true
    }).done(function(){
      setLogin();
      getGiftList();
      getActivityList();
      getCount();
      getTurnGift();
    });

  });
  $("#loginBtn").leanModal({ top : 100, overlay : 0.4, closeButton: ".modal-close" });
  $("#loginBtn").on("click",function(){
    $("#password").val("");
  });
  $("#loginBtn2").leanModal({ top : 100, overlay : 0.4, closeButton: ".modal-close" });
  // var modal = $('<a rel="leanModal" href="#friendtip"></a>');
  // $("#friendtipBtn").leanModal({ top : 200, overlay : 0.4, closeButton: ".modal-close" });
  var modal2 = $('<a rel="leanModal" href="#eggwrp"></a>');
  modal2.leanModal({ top : 0, overlay : 0.4, closeButton: ".modal-close1" });


  // 获取奖品列表
  function getGiftList(){
    var url = "http://activity.polyv.net/winner/16-06/egg";
    var $list = $("#giftList1");
    var $jsegg = $(".jsegg");
    $.ajax({
      url: url,
      dataType: 'jsonp'
    }).done(function(data){
      $list.empty();
      var len = data.length;
      var imageUrl = "dist/images/gift";
      var imageUrl2 = "dist/images/egift";
      if(len >0){
        for(var i=0;i<len;i++){
          var iurl = imageUrl + data[i].prizeEnName + ".png";
          var iurl2 = imageUrl2 + data[i].prizeEnName + ".png";
          var li = $("<li />");
          var dv = $("<div />");
          var ig = $("<img />").attr({"src":iurl,"alt":"奖品"});
          dv.append(ig);
          li.append(dv);
          $list.append(li);
          var egg = $($jsegg.eq(data[i].prizeIndex-1));
          egg.addClass("broken");
          egg.data("broken",true);
          egg.children(".egggift").append('<img src="' +iurl2+ '" />');
          egg.children(".rewardgift").empty().append("<span>"+data[i].prizeName +"</span>");
        }
      }else{
        $list.append("<li>您暂未参加此活动</li>");
        $jsegg.each(function(index){
          var egg = $($jsegg.eq(index));
          egg.removeClass("broken");
          egg.data("broken",false);
          egg.children(".egggift").empty();
          egg.children(".rewardgift").empty().append("<span>未获得该奖品</span>");
        });
      }
    });
  }
  getGiftList();

  function getTurnGift(){
    var url = "http://activity.polyv.net/winner/16-06/turntable";
    var $list = $("#giftList3");
    $.ajax({
      url: url,
      dataType: 'jsonp'
    })
    .done(function(data) {
      $list.empty();
      var len = data.length;
      var imageUrl = "dist/images/";
      if(len >0){
        for(var i=0;i<len;i++){
          var iurl = imageUrl + "r" + data[i].index + "gift" + (data[i].prizeIndex--+1) + ".png";
          var li = $("<li />");
          var dv = $("<div />");
          var ig = $("<img />").attr({"src":iurl,"alt":"奖品"});
          dv.append(ig);
          li.append(dv);
          $list.append(li);
        }
      }else {
        $list.append("<li style='text-align:left'>您暂未参加此活动</li>");
      }
    });

  }
getTurnGift();

  //活动一
  var $hammer = $("#hammer");
  $(".jsegg").each(function(index){
    $(this).data("index",index);
  });
  $(".jsegg").on("mouseover",function(){
    var eggshell = $($(this).children(".eggshell"));
    var l = eggshell.position().left + eggshell.width()-40 + "px";
    $hammer.css("left",l);
  });
  $(".jsegg").on("click",function(){
    var url = "http://activity.polyv.net/winner/16-06/hitEgg";
    var index = $(this).data("index")+1;
    var imageUrl = "dist/images/egift";
    var $giftImg = $("#eggGift");
    var $giftname = $("#eggGiftName");
    // if($(this).data("broken")) return;
    var $self = $(this);
    $.ajax({
      url: url,
      data: {index:index},
      dataType: 'jsonp'
    }).done(function(data){
      if(data.error){
        if(data.message === "用户未登录"){
          $("#loginBtn").click();
        }else{
          alert(data.message);
        }
      }else {
        var iurl = imageUrl + data.prizeEnName + ".png";
        $giftImg.empty().append('<img src="' +iurl+ '" />');
        $giftname.html(data.prizeName);
        modal2.click();
        $self.addClass("broken");
        $self.data("broken",true);
        $self.children(".egggift").append('<img src="' +iurl+ '" />');
        $self.children(".rewardgift").empty().append("<span>"+data.prizeName +"</span>");
        getCount();
      }
    });
  });


  // 活动二
  var $save = $("#save"),$savewrp = $("#savewrp");
  var $jsj2btn = $(".jsj2btn");
  var $jsm1 = $("#jsm1");
  var $jsm2 = $("#jsm2");
  var $j2result = $("#j2result");
  $("#form1").on("change",function(){
    var ary = $(this).serializeArray();
    if(ary.length ===3){
      $j2result.show();
      var val_1 = Number(ary[0].value) - 1,
          val_2 = ary[1].value,
          val_3 = Number(ary[2].value);
      var mon = Math.round( price[val_2].price[val_1]*val_3/100),
          save = mon*10;
      $jsm1.html(mon);
      $jsm2.html(save);
      var vn = val_2 == "normal" ? 0 : 1;
      paymessage.package = val_1 + 1 + vn*4;
      paymessage.discount = val_3/100;
    }else{
      $j2result.hide();
      paymessage.package = null;
      paymessage.discount = null;
    }
    $(ary).each(function(){
      var num = price[this.name];
      var ele = $jsj2btn.eq(num-1);
      if(num === 1){
        ele.html(price.name[Number(this.value) - 1]);
      }else if(num==2){
        ele.html(price[this.value].title);
      }else{
        ele.html(price.ratio[Number(this.value) - 1]);
      }
      ele.addClass("show");
    });
  });

  $("#j2ec").on("click",function(){
    $("#form1 input:checked").attr("checked",false);
    $jsj2btn.removeClass("show");
    $j2result.hide();
    paymessage.package = null;
    paymessage.discount = null;
  });

  $("#j2pda").on("click",function(){
    if(paymessage.email && paymessage.package && paymessage.discount){
      var res = $.param(paymessage);
      var url = "http://activity.polyv.net/order/16-06?";
      window.open(url+res);
    }else{
      if(!paymessage.email){
        $("#loginBtn").click();
        return;
      }else{
        alert("请选择套餐内容");
      }
    }
  });

  // 活动三
  var modal3 = $('<a rel="leanModal" href="#turnwrp"></a>');
  modal3.leanModal({ top : 0, overlay : 0.4, closeButton: ".modal-close1" });
  var $turnGift = $("#turnGift");
  var $turnGiftName = $("#turnGiftName");
  var $jsRoatebtn = $(".jsRoatebtn");
  var $jdprice  = $("#jdprice");
  // 初始化转盘按钮
  $(".jsLuck").each(function(index){
    $(this).data("roate",index);
  });
  $(".jsLuck").on("click",function(){
    var index = $(this).data("roate");
    var $form = $($(this).parent("form"));
    var key = $form.serializeArray()[0].value;
    var $btn = $jsRoatebtn.eq(index);
    var url = "http://activity.polyv.net/winner/16-06/addTurntable";
    var imgUrl = "dist/images/";
    if(!paymessage.email){
      $("#loginBtn").click();
      return;
    }
    // ajax
    $.ajax({
      url: url,
      data: {index:index+1,key:key},
      dataType: 'jsonp'
    }).done(function(data){
      if(data.error){
        alert(data.message);
      }else{
        var prizeIndex = data.prizeIndex--,
            prize = data.prize;
        var iurl = imgUrl + "r" + (index+1) + "gift" + (prizeIndex+1) + ".png";
        $turnGift.empty().append('<img src="' +iurl+'" alt="'+ prize +'" />');
        $turnGiftName.html(prize+" 或 " + data.cardPrice + "元京东礼品卡");
        $jdprice.html(data.cardPrice + "元京东礼品卡");
        $btn.rotate({
          angle: 0,
          center: ["50%", "50%"],
          animateTo:7200 + prizeIndex*60,
          duration: 5000,
          callback: function(){
            modal3.click();
            getTurnGift();
          }
        });
      }
    });
  });


});
